import { Container, Row } from "reactstrap"
import { Breadcrumbs } from "../../../../AbstractElements"
import { Chats, PrivateChat } from "../../../../Constants/Constants"
import { LeftSideBar } from "./LeftSideBar/LeftSideBar"
import { useAppDispatch } from "../../../../ReduxToolkit/Hooks"
import { useEffect } from "react"
import { fetchChatApiData, fetchChatMemberApiData } from "../../../../ReduxToolkit/Reducers/ChatSlice"
import UserChat from "./UserChat/UserChat"

const PrivateChatContainer = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchChatMemberApiData());
    dispatch(fetchChatApiData());
  }, [dispatch]);
  return (
    <>
    <Breadcrumbs mainTitle={PrivateChat} parent={Chats} />
    <Container fluid>
      <Row className="g-0">
        <LeftSideBar />
        <UserChat />
      </Row>
    </Container>
  </>
  )
}

export default PrivateChatContainer